import React, { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';
import { LoginContainerStyle } from 'pages/auth/Auth.style';

import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as LightBgImage } from 'assert/images/Common/lightMode.svg';
import { ReactComponent as DarkBgImage } from 'assert/images/Common/darkMode.svg';
import { ReactComponent as WafyNetLogo } from 'assert/images/Common/wafynetLogo.svg';
import { ReactComponent as Translation } from 'assert/images/Common/translation.svg';
import { ReactComponent as DarkTheme } from 'assert/images/Common/darkTheme.svg';
import { ReactComponent as LightTheme } from 'assert/images/Common/lightTheme.svg';
import { ProfilePopoverContent } from 'pages/layout/Header.style';
import { useDispatch } from 'react-redux';
import { changeMode } from 'redux/features/LoginSlice';
import { useTranslation } from 'react-i18next';
import { CustomPopover } from 'components';
import { LanguageList } from 'assert/OptionList';

const AuthWrapper = ({ children, page, isModal }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { i18n } = useTranslation();

  const [openDropdown, setOpenDropdown] = useState(false);

  const currentTheme = localStorage.getItem('mode');

  const [language, setLanguage] = useState(
    localStorage.getItem('language') || 'en'
  );

  useEffect(() => {
    const handleLanguageChange = (lng) => {
      setLanguage(lng);
    };
    i18n.on('languageChanged', handleLanguageChange);

    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, []);

  const toggleTheme = () => {
    localStorage.setItem('mode', currentTheme === 'Dark' ? 'Light' : 'Dark');
    dispatch(changeMode(currentTheme === 'Dark' ? 'Light' : 'Dark'));
  };

  const handleLanguageChange = (langCode) => {
    i18n.changeLanguage(langCode);
    localStorage.setItem('language', langCode);
    setOpenDropdown(false);
  };

  const renderLanguageList = () => {
    return (
      <ProfilePopoverContent>
        {LanguageList.map((lang) => {
          return (
            <div
              className={clsx(
                'language-item',
                language === lang.value && 'language-active-item'
              )}
              key={lang.value}
              onClick={() => handleLanguageChange(lang.value)}
            >
              {lang.label}
            </div>
          );
        })}
      </ProfilePopoverContent>
    );
  };

  return (
    <LoginContainerStyle>
      {isModal ? (
        <div className={clsx('logincard', page && 'removeBgShadow')}>
          {children}
        </div>
      ) : (
        <>
          <div className="company-brand-container">
            <div className="company-brand">
              <WafyNetLogo />
              <h1 className="logo-title">WafyNet</h1>
            </div>
            <div className="option-header">
              <div onClick={toggleTheme}>
                {currentTheme === 'Dark' ? (
                  <LightTheme className="icon-style" />
                ) : (
                  <DarkTheme className="icon-style" />
                )}
              </div>
              <CustomPopover
                isOpen={openDropdown}
                handlePopoverClick={() => setOpenDropdown(true)}
                onClose={() => setOpenDropdown(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                action={<Translation className="icon-style" />}
                content={renderLanguageList()}
              />
            </div>
          </div>
          <div className="auth-content-container">
            <div className="img-container">
              {theme.mode === 'light' ? (
                <LightBgImage className="login-img" />
              ) : (
                <DarkBgImage className="login-img" />
              )}
              <div className="login-block">
                <div className="auth-apploication-title">
                  <div>{t('Auth.WafyThemeText')}</div>
                </div>
                <div
                  className={clsx('logincard', page && 'removeBgShadow')}
                  key={i18n.language}
                >
                  {children}
                </div>
              </div>
              <div className="policy-container">
                <div onClick={() => navigate('/about-us')}>
                  {t('HomePage.AboutUs')}
                </div>
                <div onClick={() => navigate('/privacy-policy')}>
                  {t('HomePage.PrivacyPolicy')}
                </div>
                <div onClick={() => navigate('/terms')}>
                  {t('HomePage.Terms')}
                </div>
                <div onClick={() => navigate('/safety-standard')}>
                  Safety Standard
                </div>
                <div onClick={() => navigate('/blog')}>
                  {t('HomePage.Blog')}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </LoginContainerStyle>
  );
};

export default AuthWrapper;
